import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IFindAllFinishedOrderRequest,
  IOrderLabelingInitialState,
} from "./orderLabelingModel";
import {
  findAllFinishedOrder,
  findOrderLabelingById,
  findOrderLabelingViewById,
  updateOrderLabeling,
} from "./services/orderLabeling.services";
import { findAllOrderLabelandPurchaseData } from "../order/services/order.services";

const initialState: IOrderLabelingInitialState = {
  loading: false,
  error: "",
  finishedOrderList: [],
  deleteDialogOpen: false,
  deletItemInsex: null,
  orderLabelingDetail: {
    order_id: null,
    GrossWeight: null,
    LessWeight: null,
    NetWeight: null,
    ORDERLabeling: [
      {
        ItemName: "",
        Weight: null,
        Pcs: null,
        CustomerRate: null,
        Total: null,
      },
    ],
  },
  filter: {
    order_no: null,
    party_name: "",
    item_name: "",
    fromDate: "",
    toDate: "",
  },
};

const orderLabelingSlice = createSlice({
  name: "orderLabeling",
  initialState,
  reducers: {
    setFilterOrderLabeling: (
      state,
      action: PayloadAction<IFindAllFinishedOrderRequest>,
    ) => {
      state.filter = action.payload;
    },
    clearFilterOrderLabeling: (state) => {
      state.filter = initialState.filter;
    },
    clearOrderLabelingDetail: (state) => {
      state.orderLabelingDetail = initialState.orderLabelingDetail;
    },
    setOpenDeleteDialog: (state, action) => {
      state.deleteDialogOpen = true;
      state.deletItemInsex = action.payload;
    },
    setCloseDeleteDialog: (state) => {
      state.deleteDialogOpen = false;
      state.deletItemInsex = null;
    },
  },
  extraReducers: (builder) => {
    // Find All Finished Orders
    builder.addCase(findAllOrderLabelandPurchaseData.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllOrderLabelandPurchaseData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.finishedOrderList = action.payload.Data;
      },
    );
    builder.addCase(
      findAllOrderLabelandPurchaseData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.finishedOrderList = [];
      },
    );
    // Find All Finished Orders
    builder.addCase(findAllFinishedOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findAllFinishedOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.finishedOrderList = action.payload.Data;
    });
    builder.addCase(findAllFinishedOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.finishedOrderList = [];
    });

    // Find Order Labeling By ID
    builder.addCase(findOrderLabelingById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findOrderLabelingById.fulfilled, (state, action) => {
      state.loading = false;
      state.orderLabelingDetail = action.payload;
    });
    builder.addCase(findOrderLabelingById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.orderLabelingDetail = initialState.orderLabelingDetail;
    });

    // Find Order Labeling View By ID
    builder.addCase(findOrderLabelingViewById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findOrderLabelingViewById.fulfilled, (state, action) => {
      state.loading = false;
      state.orderLabelingDetail = action.payload;
    });
    builder.addCase(findOrderLabelingViewById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.orderLabelingDetail = initialState.orderLabelingDetail;
    });

    // Update Order Labeling
    builder.addCase(updateOrderLabeling.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateOrderLabeling.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateOrderLabeling.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setFilterOrderLabeling,
  clearFilterOrderLabeling,
  clearOrderLabelingDetail,
  setOpenDeleteDialog,
  setCloseDeleteDialog,
} = orderLabelingSlice.actions;

export default orderLabelingSlice.reducer;
